import { render, staticRenderFns } from "./workload-form.vue?vue&type=template&id=6a82d7d0&"
import script from "./workload-form.vue?vue&type=script&lang=js&"
export * from "./workload-form.vue?vue&type=script&lang=js&"
import style0 from "./workload-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports